export default __webpack_public_path__ + "static/media/carousel-1.bb1f4524.jpg";